<template>
  <v-card elevation="2">
    <v-toolbar color="primary" dark flat>
      <v-icon left>mdi-gavel</v-icon>
      <v-toolbar-title>Case Files</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('add-case')" v-if="canEdit">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text v-if="cases.length === 0" class="text-center py-8">
      <v-icon size="64" color="grey lighten-1">mdi-folder-open</v-icon>
      <p class="text-h6 grey--text mt-4">No case files yet</p>
      <v-btn color="primary" @click="$emit('add-case')" v-if="canEdit">
        <v-icon left>mdi-plus</v-icon>
        Create First Case
      </v-btn>
    </v-card-text>

    <v-list v-else two-line>
      <v-list-item-group>
        <template v-for="(caseFile, index) in cases">
          <v-list-item :key="caseFile.id" @click="$emit('view-case', caseFile)">
            <v-list-item-avatar>
              <v-icon :color="getStatusColor(caseFile.status)">
                {{ getCaseIcon(caseFile.status) }}
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ caseFile.title }}</v-list-item-title>
              <v-list-item-subtitle>
                <v-chip v-if="caseFile.court" x-small class="mr-2">
                  {{ caseFile.court.name }}
                </v-chip>
                <v-chip
                  x-small
                  :color="getStatusColor(caseFile.status)"
                  dark
                  v-if="caseFile.status"
                >
                  {{ caseFile.status.name }}
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action v-if="canEdit">
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="$emit('edit-case', caseFile)">
                    <v-list-item-icon>
                      <v-icon>mdi-pencil</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$emit('delete-case', caseFile.id)">
                    <v-list-item-icon>
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-action>
          </v-list-item>
          <v-divider
            :key="'div-' + index"
            v-if="index < cases.length - 1"
          ></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: "LegalCaseFiles",

  props: {
    cases: {
      type: Array,
      default: () => [],
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getStatusColor(status) {
      if (!status) return "grey";
      const statusName = status.name ? status.name.toLowerCase() : "";

      const colors = {
        active: "green",
        pending: "orange",
        completed: "blue",
        closed: "grey",
        "on hold": "amber",
      };

      return colors[statusName] || "grey";
    },

    getCaseIcon(status) {
      if (!status) return "mdi-file-document";
      const statusName = status.name ? status.name.toLowerCase() : "";

      const icons = {
        active: "mdi-progress-clock",
        pending: "mdi-timer-sand",
        completed: "mdi-check-circle",
        closed: "mdi-close-circle",
        "on hold": "mdi-pause-circle",
      };

      return icons[statusName] || "mdi-file-document";
    },
  },
};
</script>
